(function($) {
    $(function() {
        showRetailers = function($button, $layout) {
            $button.click(function(e) {
                if( !$(this).next().hasClass('open') ) {
                    $layout.find('.sp__the-retailers--list.open').removeClass('open');
                    $(this).next().addClass('open');
                } else {
                    $(this).next().removeClass('open');
                }
            });
        };
        var $layout = $('.search-grid, .search-list');
        var $selectedLayout = $('.supapress').find($layout);
        if( $selectedLayout ) {
            var $retailerBtn = $selectedLayout.find('.js-show-sp__the-retailers');
            showRetailers($retailerBtn, $selectedLayout);
        }
    });
})(jQuery);





